/**
 * Paginação indexável com rel="next" e rel="prev".
 */

import { buildListingCanonicalPath } from './urlHelpers';

export const LISTING_PAGE_SIZE = 12;

export function getTotalPages(totalItems, pageSize = LISTING_PAGE_SIZE) {
  return Math.max(1, Math.ceil(totalItems / pageSize));
}

export function getPageSlice(items, page = 1, pageSize = LISTING_PAGE_SIZE) {
  const safePage = Math.max(1, parseInt(page, 10) || 1);
  const start = (safePage - 1) * pageSize;
  return {
    page: safePage,
    items: (items || []).slice(start, start + pageSize),
    totalPages: getTotalPages(items?.length || 0, pageSize),
    totalItems: items?.length || 0,
  };
}

export function buildPaginationUrls(filters, currentPage, totalPages, baseUrl) {
  const base = (baseUrl || '').replace(/\/$/, '');

  const prevPage = currentPage > 1 ? currentPage - 1 : null;
  const nextPage = currentPage < totalPages ? currentPage + 1 : null;

  const build = (page) => `${base}${buildListingCanonicalPath(filters, page)}`;

  return {
    prev: prevPage ? build(prevPage) : null,
    next: nextPage ? build(nextPage) : null,
    current: build(currentPage),
  };
}

export function getPaginationRelLinks(filters, currentPage, totalPages, baseUrl) {
  const urls = buildPaginationUrls(filters, currentPage, totalPages, baseUrl);
  const links = [];

  if (urls.prev) links.push({ rel: 'prev', href: urls.prev });
  if (urls.next) links.push({ rel: 'next', href: urls.next });

  return links;
}
